// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","imageWithTextProductDetailsSection":"imageWithTextProductDetailsSection_imageWithTextProductDetailsSection__GjtFk"};